import { useEffect } from "react";
import { useForm } from "react-hook-form";
import PermissionForm from "./PermissionForm";

const ModelEditPermission = (props) => {
  const { isOpen, onOk, onCancel, permission } = props;
  const hookForm = useForm({
    defaultValues: {
      name: "",
      label: "",
    },
  });
  useEffect(() => {
    if (permission) {
      hookForm.reset({
        name: permission.name || "",
        label: permission.label || "",
        parent_id: permission.parent_id,
      });
    }
  }, [permission, hookForm]);
  return (
    <PermissionForm
      isOpen={isOpen}
      onOk={(data) => onOk(data)}
      onCancel={onCancel}
      hookForm={hookForm}
    />
  );
};
export default ModelEditPermission;
